var $ = require( "jquery" );
window.jQuery = $; window.$ = $;

// Mobile Nav
(function() {
	$('#nav-icon3').click(function(){
		$('body').toggleClass('no-scroll');
		$(this).toggleClass('open');
		// $('.header-menu').slideToggle();
		$('.menu').slideToggle();
		$('#mobile-nav').toggleClass('scroll');
		$('.isi-sticky').toggleClass('hidden');
	});

	$('.header-menu .menu-item-has-children').append('<span class="open-menu"><div>&#9662;</div></span>'); 
	$('.open-menu').click(function() {
		$(this).find('div').toggleClass('rotate')
		$(this).parent().toggleClass('active')
		$(this).prev('.sub-menu').toggleClass('active');
    $(this).parent().prevAll().removeClass('active');
    $(this).parent().nextAll().removeClass('active');
		$(this).parent().prevAll().find('.sub-menu').removeClass('active');
		$(this).parent().nextAll().find('.sub-menu').removeClass('active');
	})
})();

// Mobile nav items container dynamic y position
(function() {
	// Function to run when the browser is resized
    function handleResize() {
        // Check if the browser width is less than (X)px
        var getHeaderHeight = $('header').height();
        
        if ($(window).width() < 1311) {
            $('#mobile-nav').css('top', getHeaderHeight);
        }
    }

    // Bind the resize event
    $(window).resize(handleResize);

    // Call the function once initially to handle any initial size
    handleResize();
})();

// Toggle Tab Footer
(function() {
  $('.isi-sticky .view-more').on('click', function() {
    $('.isi-sticky').toggleClass('on');
    $('body').toggleClass('no-scroll');
  })
})();

// Tooltip
(function() {
  $('.tooltip').on('click', function() {
    $(this).parent().next('.tooltip-msg').toggleClass('hidden');
  })
})();

// Scroll
(function() {
	var $scrollTrigger = $('.isi');
  var isiStickyHeight = $('.isi-sticky').height();

  $(window).on('resize', function() {
    isiStickyHeight = $('.isi-sticky').height();
  });
  
  $(window).on('scroll', function() {
    var windowBottom = $(window).scrollTop() + $(window).height();
    var triggerTop = $scrollTrigger.offset().top + isiStickyHeight;
    var triggerBottom = $scrollTrigger.offset().top + $scrollTrigger.height();

    if (windowBottom >= triggerTop) {
      $('.isi-sticky').addClass('hidden');
    } else {
      $('.isi-sticky').removeClass('hidden');
    }
  });
})();

// Nav hide on scroll-down, show on scroll-up
(function() {
	var previousScroll = 0;
  var $navbar = $('header');
  var $stickybar = $('.js-sticky-nav');
  var stickyPresent;

  $(window).scroll(function() {
    var currentScroll = $(window).scrollTop();
    if ($stickybar.length > 0) {
      stickyPresent = true;
    }

    if (currentScroll > previousScroll) {
      // Scrolling down, hide the navigation
      $navbar.css('top', -$navbar.height() + 'px');
      $('body').addClass('scrolling-down');
      if (stickyPresent) {
        $stickybar.css('top', '0px');
      }
    } else {
      // Scrolling up, show the navigation
      $navbar.css('top', '0');
      $('body').removeClass('scrolling-down');
      if (stickyPresent) {
        $stickybar.css('top', $navbar.height() + 'px');
      }
    }

    previousScroll = currentScroll;
  });
})();

// ISI Sticky
(function() {
	$('.tabs-footer').find('.btn').on('click', function() {
		$(this).toggleClass('active');
		$(this).parent().next().slideToggle();
		$(this).parent().parent().toggleClass('bg-color');
	})
})();
(function() {
	$('.tabs-footer').find('.button').on('click', function() {
		$(this).toggleClass('active');
		$(this).parent().next().slideToggle();
		$(this).parent().parent().toggleClass('bg-color');
	})
})();


// Accordion Trigger
(function() {
  $('.accordion-header').click(function() {
    $(this).toggleClass('active');
    $(this).next('.accordion-content').slideToggle();
  });
})();


(function() {
  $('.accordion .heading').click(function() {
    $(this).parent().toggleClass('active');
    $(this).next().slideToggle();
  });
})();

// Form input button toggle class
(function() {
  $('.gfield_radio label').click(function() {
    $(this).parent().prevAll().find('label').removeClass('active');
    $(this).parent().nextAll().find('label').removeClass('active');
    $(this).addClass('active');
  });
})();


// Terms Modal Trigger
(function() {
  $('#terms-modal-btn').click(function() {
    $('#terms-modal').removeClass('hidden');
    $('body').addClass('scroll-lock');
  });
})();
(function() {
  $('#terms-modal button').click(function() {
    $('#terms-modal').addClass('hidden');
    $('body').removeClass('scroll-lock');
  });
})();

// Video Thumbnail Switch
(function() {
  $('.video-poster').click(function() {
    var iframe = document.querySelector('iframe');
    var player = new Vimeo.Player(iframe);
    player.play();
    $('.video iframe').removeClass('hidden');
  });
})();


// Sub page link scrolling
var offsetHeight = 0;
var hideNav = false;
(function() {
  // Disable automatic scroll restoration to prevent jumping back to the top
  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }

  $(document).ready(function() {
    if (location.hash) {
      // Close all accordions
      $('.accordion-wrapper .accordion-header').each(function() {
        if ($(this).hasClass('active')) {
          $(this).removeClass('active');
        }
      });
      $('.accordion-wrapper .accordion-content').each(function() {
        if ($(this).hasClass('block')) {
          $(this).removeClass('block');
        }
      });
      // Open new accordion
      $(location.hash + ' .accordion-header').addClass('active');
      $(location.hash + ' .accordion-content').addClass('block');
      // Cookies offset
      offsetHeight = $('body').css('padding-top');
      offsetHeight = offsetHeight.substring(0, offsetHeight.length - 2);
      var scrollTarget = location.hash.length ? location.hash : $('[name=' + this.hash.slice(1) + ']');
      // Does a scroll target exist?
      if (scrollTarget.length && scrollTarget != "#nexlizet" && scrollTarget != "#nexletol") {
        // Scroll page
        $('html, body').animate({
          scrollTop: $(location.hash).offset().top - (offsetHeight + 50)
        }, 100, function() {
          // Nav offset
          setTimeout(function() {
            $('header').css('top', '-1000px');
          }, 50);
        });
      }
    }
  });

  // Subpage link clicked
  $(document).ready(function() {
    $('a[href*="#"]').not('[href="#"]').not('[href="#0"]').not('.tablinks').click(function(event) {
      // Close nav menu
      if ($('#mobile-nav').hasClass('scroll')) {
        $('#nav-icon3').click();
      }
      // Open new accordion
      $(this.hash + ' .accordion-header').addClass('active');
      $(this.hash + ' .accordion-content').addClass('block');
      // Cookies offset
      offsetHeight = $('body').css('padding-top');
      offsetHeight = offsetHeight.substring(0, offsetHeight.length - 2);
      // On-page links
      if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
        // Figure out element to scroll to
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
        // Does a scroll target exist?
        if (target.length) {
          // Only prevent default if animation is actually gonna happen
          event.preventDefault();
          $('html, body').animate({
            scrollTop: target.offset().top - offsetHeight
          }, 1000, function() {
            // Callback after animation
            // Nav hide
            setTimeout(function() {
              $('header').css('top', '-1000px');
            }, 50);
          });
        }
      }
    });
  });
})();


// Add class if url matches
(function() {
  $(document).ready(function() {

    if (window.location.hash.toLowerCase().includes("nexletol")) {
      //setNexletolActive();
    }
    if (window.location.href.indexOf("nexletol") > -1) {
      //setNexletolActive();
    }
    function containsWord(item, word) {
      var wordItem = item.text().toLowerCase();
      var targetWord = word.toLowerCase();
      return wordItem.indexOf(targetWord) !== -1;
    }

    $('.header-menu > li a').each(function() {
      if(containsWord($(this), 'nexletol')) {
        $(this).parent().addClass('nexletol-item');
        $(this).on("click", function() {
          setNexletolActive();
        });
      }
      if(containsWord($(this), 'nexlizet')) {
        $(this).on("click", function() {
          setNexlizetActive();
        });
      }
    })
    /*$('.tab.header a').each(function() {
      if(containsWord($(this), 'nexletol')) {
        $(this).on("click", function() {
          setNexletolActive();
        });
      }
      if(containsWord($(this), 'nexlizet')) {
        $(this).on("click", function() {
          setNexlizetActive();
        });
      }
    })*/

    // if($('.header-menu > li a').indexOf("nexletol") > 1) {
    //   $(this).addClass('nexletol-item');
    // }
  });
})();

function setNexletolActive() {
  $('body').addClass('nexletol');
  $(".tab.header a:first-child").removeClass("active");
  $(".tab.header a:last-child").addClass('active');
  $(".nexletol #nexlizet-lowering, .nexletol #nexlizet-works").css('display', 'none');
  $(".nexletol #nexletol-lowering, .nexletol #nexletol-works").css('display', 'block');
  $("section.bm-lgold").addClass('bm-lblue');
  $('.equal').matchHeight();
}

function setNexlizetActive() {
  $('body').removeClass('nexletol');
  $(".tab.header a:first-child").addClass("active");
  $(".tab.header a:last-child").removeClass('active');
  $(".nexletol #nexlizet-lowering, .nexletol #nexlizet-works").css('display', 'block');
  $(".nexletol #nexletol-lowering, .nexletol #nexletol-works").css('display', 'none');
  $("section.bm-lgold").removeClass('bm-lblue');
  $('.equal').matchHeight();
}

$(function () {

  // Define each group: which child-range to show, plus the H1 text and image to swap in
  // Group 1 LDL Nexlizet
  // Group 2 LDL Nexletol
  // Group 3 Study Nexlizet
  // Group 4 Study Nexletol
  const groups = {
    1: {
      range: [4, 5], title: "Is NEXLIZET right for you?",
      jpg: "/wp-content/uploads/2026/06/hero3.jpg",
      webp: "/wp-content/uploads/2026/06/hero3.webp",
      jpgMobile: "/wp-content/uploads/2026/06/hero_1.jpg",
      webpMobile: "/wp-content/uploads/2026/06/hero_1.webp"
    },
    2: {
      range: [2, 3], title: "Is NEXLETOL right for you?",
      jpg: "/wp-content/uploads/2026/06/NN_Consumer_Homepage_Desktop_Patio-scaled-1.jpg",
      webp: "/wp-content/uploads/2026/06/NN_Consumer_Homepage_Desktop_Patio-scaled-1.webp",
      jpgMobile: "/wp-content/uploads/2026/06/hero_2.jpg",
      webpMobile: "/wp-content/uploads/2026/06/hero_2.webp"
    },
    3: {
      range: [5, 7], title: "How can NEXLIZET help you?",
      jpg: "/wp-content/uploads/2026/06/hero3.jpg",
      webp: "/wp-content/uploads/2026/06/hero3.webp",
      jpgMobile: "/wp-content/uploads/2026/06/hero_1.jpg",
      webpMobile: "/wp-content/uploads/2026/06/hero_1.webp"
    },
    4: {
      range: [2, 4], title: "How can NEXLETOL help you?",
      jpg: "/wp-content/uploads/2026/06/NN_Consumer_Homepage_Desktop_Patio-scaled-1.jpg",
      webp: "/wp-content/uploads/2026/06/NN_Consumer_Homepage_Desktop_Patio-scaled-1.webp",
      jpgMobile: "/wp-content/uploads/2026/06/hero_2.jpg",
      webpMobile: "/wp-content/uploads/2026/06/hero_2.webp"
    }
  };

  function showGroup(key) {
    const g = groups[key];
    if (!g) return;

    const [start, end] = g.range;
    const $sections = $('main section');

    // Show everything by default, then hide the sections for the active group.
    $sections.show();
    $sections.filter(function () {
      const index = $sections.index(this) + 1; // 1-based index within main section elements
      return index >= start && index <= end && index !== 1; // keep the first section visible
    }).hide();

    // Swap H1 text
    $('h1').text(g.title);

    // Swap picture sources: mobile webp/jpg, then desktop webp source, then jpg fallback img
    $('#main-image-webp-mobile').attr('srcset', g.webpMobile);
    $('#main-image-jpg-mobile').attr('srcset', g.jpgMobile);
    $('#main-image-webp').attr('srcset', g.webp);
    $('#main-image').attr('src', g.jpg);
  }

  function scrollToHashIfNeeded() {
    const hash = window.location.hash;
    const lower = hash.toLowerCase();

    if (!hash || hash === '#' || lower === '#nexletol' || lower === '#nexlizet') {
      return;
    }

    const $target = $(hash);
    if ($target.length) {
      // Small delay lets the browser finish layout after .show() before scrolling
      setTimeout(function () {
        $target[0].scrollIntoView({ behavior: 'instant', block: 'start' });
        setTimeout(function() {
          $('header').css('top', -$('header').height() + 'px');
        }, 50);
      }, 100);
    }
  }

  function handleHash() {
    const path = window.location.pathname;
    const hash = window.location.hash.toLowerCase();


    if (path.indexOf('/ldl-lowering-treatments/') !== -1) {
      // On this page: choose between Group 1 and Group 2
      if (hash.indexOf('nexletol') !== -1 || hash.indexOf('how-nexletol-works') !== -1) {
        showGroup(2);
        setNexletolActive();
        openProduct(event,'nexletol-works');
      } else {
        showGroup(1); // covers #nexlizet, #how-nexlizet-works, and no-hash cases
        setNexlizetActive();
        openProduct(event,'nexlizet-works');
      }
    } else if (path.indexOf('/study-results/') !== -1) {
      // On this page: choose between Group 3 and Group 4
      if (hash.indexOf('nexletol') !== -1) {
        showGroup(4);
        setNexletolActive();
        openProduct(event,'nexletol-lowering');
      } else {
        showGroup(3); // covers #nexlizet and no-hash cases
        setNexlizetActive();
        openProduct(event,'nexlizet-lowering');
      }
    }
    scrollToHashIfNeeded();
  }

  // Re-check whenever the hash changes (e.g. user clicks an in-page anchor link)
  $(window).on('hashchange', handleHash);

  // Run once on page load
  $(document).ready(function() {
    handleHash();
  })
});

function openProduct(evt, productName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    //tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  document.getElementById(productName).style.display = "block";
  //evt.currentTarget.className += " active"; 

}


// Cookie Section
(function() {	
  $(document).ready(function() {
      // Function to check visibility
      function checkDivVisibility() {
	      	function setTargetHeight() {
	            var cookieBarHeight = $("#cookie-law-info-bar").height();
	            $('body').css('padding-top', cookieBarHeight);
	        }
          if ($("#cookie-law-info-bar").is(":visible")) {
			        setTargetHeight()
          } else {
              $('body').css('padding-top', 0);
          }

          $(window).resize(function() {
            // setTargetHeight();
            if ($("#cookie-law-info-bar").is(":visible")) {
			        setTargetHeight()
	          } else {
	              $('body').css('padding-top', 0);
	          }
        });
      }

      // Check visibility on page load
      checkDivVisibility();

      // Check visibility on button click
      $("#wt-cli-accept-all-btn").click(function() {
          $('body').css('padding-top', 0);          
      });
  });
})();

// Stop images from being wrapped in <p>
$('p').each(function() {
    // Check if the paragraph contains only one child element and it's an image
    if ($(this).children().length === 1 && $(this).children().is('img')) {
        // Replace the paragraph with the image
        $(this).replaceWith($(this).children());
    }
});

/**
* jquery.matchHeight-min.js v0.5.2
* http://brm.io/jquery-match-height/
* License: MIT
*/
(function(b){b.fn.matchHeight=function(a){if("remove"===a){var d=this;this.css("height","");b.each(b.fn.matchHeight._groups,function(b,a){a.elements=a.elements.not(d)});return this}if(1>=this.length)return this;a="undefined"!==typeof a?a:!0;b.fn.matchHeight._groups.push({elements:this,byRow:a});b.fn.matchHeight._apply(this,a);return this};b.fn.matchHeight._apply=function(a,d){var c=b(a),e=[c];d&&(c.css({display:"block","padding-top":"0","padding-bottom":"0","border-top-width":"0","border-bottom-width":"0",
height:"100px"}),e=k(c),c.css({display:"","padding-top":"","padding-bottom":"","border-top-width":"","border-bottom-width":"",height:""}));b.each(e,function(a,c){var d=b(c),e=0;d.each(function(){var a=b(this);a.css({display:"block",height:""});a.outerHeight(!1)>e&&(e=a.outerHeight(!1));a.css({display:""})});d.each(function(){var a=b(this),c=0;"border-box"!==a.css("box-sizing")&&(c+=g(a.css("border-top-width"))+g(a.css("border-bottom-width")),c+=g(a.css("padding-top"))+g(a.css("padding-bottom")));
a.css("height",e-c)})});return this};b.fn.matchHeight._applyDataApi=function(){var a={};b("[data-match-height], [data-mh]").each(function(){var d=b(this),c=d.attr("data-match-height");a[c]=c in a?a[c].add(d):d});b.each(a,function(){this.matchHeight(!0)})};b.fn.matchHeight._groups=[];b.fn.matchHeight._throttle=80;var h=-1,f=-1;b.fn.matchHeight._update=function(a){if(a&&"resize"===a.type){a=b(window).width();if(a===h)return;h=a}-1===f&&(f=setTimeout(function(){b.each(b.fn.matchHeight._groups,function(){b.fn.matchHeight._apply(this.elements,
this.byRow)});f=-1},b.fn.matchHeight._throttle))};b(b.fn.matchHeight._applyDataApi);b(window).bind("load resize orientationchange",b.fn.matchHeight._update);var k=function(a){var d=null,c=[];b(a).each(function(){var a=b(this),f=a.offset().top-g(a.css("margin-top")),h=0<c.length?c[c.length-1]:null;null===h?c.push(a):1>=Math.floor(Math.abs(d-f))?c[c.length-1]=h.add(a):c.push(a);d=f});return c},g=function(a){return parseFloat(a)||0}})(jQuery);


$('.equal').matchHeight();



// Lightbox
!function(c){c.fn.lightbox_me=function(d){return this.each(function(){var o=c.extend({},c.fn.lightbox_me.defaults,d),e=c(),n=c(this),i=c('<iframe id="foo" style="z-index: '+(o.zIndex+1)+';border: none; margin: 0; padding: 0; position: absolute; width: 100%; height: 100%; top: 0; left: 0; filter: mask();"/>');function t(){n[0].style;o.destroyOnClose?n.add(e).remove():n.add(e).hide(),o.parentLightbox&&o.parentLightbox.fadeIn(200),o.preventScroll&&c("body").css("overflow",""),i.remove(),n.undelegate(o.closeSelector,"click"),n.unbind("close",t),n.unbind("repositon",s),c(window).unbind("resize",l),c(window).unbind("resize",s),c(window).unbind("scroll",s),c(window).unbind("keyup.lightbox_me"),o.onClose()}function l(){c(window).height()<c(document).height()?(e.css({height:c(document).height()+"px"}),i.css({height:c(document).height()+"px"})):e.css({height:"100%"})}function s(){var e;n[0].style;n.css({left:"50%",marginLeft:n.outerWidth()/2*-1,zIndex:o.zIndex+3}),n.height()+80>=c(window).height()&&"absolute"!=n.css("position")?(e=c(document).scrollTop()+40,n.css({position:"absolute",top:e+"px",marginTop:0})):n.height()+80<c(window).height()&&(o.centered?n.css({position:"fixed",top:"50%",marginTop:n.outerHeight()/2*-1}):n.css({position:"fixed"}).css(o.modalCSS),o.preventScroll&&c("body").css("overflow","hidden"))}o.showOverlay&&(e=0<c(".js_lb_overlay:visible").length?c('<div class="lb_overlay_clear js_lb_overlay"/>'):c('<div class="'+o.classPrefix+'_overlay js_lb_overlay"/>')),c("body").append(n.hide()).append(e),o.showOverlay&&(l(),e.css({position:"absolute",width:"100%",top:0,left:0,right:0,bottom:0,zIndex:o.zIndex+2,display:"none"}),e.hasClass("lb_overlay_clear")||e.css(o.overlayCSS)),o.showOverlay?e.fadeIn(o.overlaySpeed,function(){s(),n[o.appearEffect](o.lightboxSpeed,function(){l(),s(),o.onLoad()})}):(s(),n[o.appearEffect](o.lightboxSpeed,function(){o.onLoad()})),o.parentLightbox&&o.parentLightbox.fadeOut(200),c(window).resize(l).resize(s).scroll(s),c(window).bind("keyup.lightbox_me",function(e){(27==e.keyCode||27==e.DOM_VK_ESCAPE&&0==e.which)&&o.closeEsc&&t()}),o.closeClick&&e.click(function(e){t(),e.preventDefault}),n.delegate(o.closeSelector,"click",function(e){t(),e.preventDefault()}),n.bind("close",t),n.bind("reposition",s)})},c.fn.lightbox_me.defaults={appearEffect:"fadeIn",appearEase:"",overlaySpeed:250,lightboxSpeed:300,closeSelector:".close",closeClick:!0,closeEsc:!0,destroyOnClose:!1,showOverlay:!0,parentLightbox:!1,preventScroll:!1,onLoad:function(){},onClose:function(){},classPrefix:"lb",zIndex:999,centered:!1,modalCSS:{top:"40px"},overlayCSS:{background:"black",opacity:.3}}}(jQuery);


$('.terms-of-use-modal').click(function(e) {
    $('.modal').lightbox_me({
        centered: true        
        });
    e.preventDefault();
});